/**
 * URLs del frontend de NeoAdmin. El origen se toma de REACT_APP_URL_LOGIN_ADMIN
 * (ya configurada en cada ambiente) para no agregar otra variable de entorno.
 */
const origenNeoAdmin = () => {
    try {
        return new URL(process.env.REACT_APP_URL_LOGIN_ADMIN).origin;
    } catch (error) {
        return '';
    }
};

// Datos personales del cliente en sesión ("Mi cuenta" en NeoAdmin)
export const miCuenta = () => `${origenNeoAdmin()}/cliente/cuenta`;

// Datos de la cuenta de un cliente, para el ejecutivo
export const cuentaCliente = (uid) => `${origenNeoAdmin()}/admin/clientes/cuenta/${encodeURIComponent(uid)}`;
